import {
  DisplayType,
  FieldTypeEnum,
  KeyValueFormattingModel,
  KeyValueRestrictionModel,
} from '@models/module/fields/enums';
import { ColumnPriorityType } from '@shared/components/data-list/common';

export interface DataListFields {
  id?: number;
  systemName: string;
  name: string;
  hasMultipleValues: boolean;
  dataSourceId?: number;
  relationId?: number;
  typeId?: FieldTypeEnum;
  displayTypeId?: DisplayType;
  label: string;
  position?: number;
  priority?: ColumnPriorityType;
  width?: number;
  printable: boolean;
  showThumbnail: boolean;
  showColorCode: boolean;
  isPrimarySort: boolean;
  isDescending: boolean;
  isFilter: boolean;
  isPayment: boolean;
  isContractSystemField: boolean;
  options: string;
  inUse: boolean;
  formattings: KeyValueFormattingModel[];
  restrictions: KeyValueRestrictionModel[];
}
